'use client';
import { btnNeutral } from '@/lib/ui';

import { motion } from 'framer-motion';
import Link from 'next/link';

export function FooterSection() {
  return (
    <section className="snap-start relative overflow-hidden bg-[#050A15] min-h-[800px] flex flex-col justify-end">
      {/* Background Image with Fade */}
      <div
        className="absolute inset-0 z-0 opacity-40 mix-blend-screen dark:invert dark:hue-rotate-180"
        style={{
          backgroundImage: 'url(/backgrounds/bg-3.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      {/* Gradient overlays to fade into the image */}
      <div className="absolute inset-0 z-0 bg-gradient-to-b from-white dark:from-[#050A15] via-transparent to-[#050A15] dark:to-white" />
      <div className="absolute inset-0 z-0 bg-gradient-to-t from-[#050A15] via-[#050A15]/80 to-transparent" />

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center flex-1 pb-8 w-full">
        <div className="max-w-[1200px] mx-auto px-6 sm:px-12 lg:px-20 flex flex-col items-center justify-center flex-1 w-full">
          {/* CTA section — vertically centered */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center flex flex-col items-center justify-center flex-1 py-20"
          >
            <h2
              className="text-white text-[32px] sm:text-[44px] font-light mb-4 leading-[1.2]"
              style={{ fontFamily: 'Nunito, sans-serif' }}
            >
              Start monitoring your agents today
            </h2>
            <p
              className="text-white/60 text-[16px] sm:text-[18px] max-w-[480px] mx-auto leading-[1.6] mb-10"
              style={{ fontFamily: 'Nunito, sans-serif', fontWeight: 300 }}
            >
              Inspect a recorded failure or follow the quickstart to send your first agent trace.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a
                href="/docs/quickstart"
                className={`${btnNeutral} group inline-flex items-center gap-2 px-8 py-3.5 rounded-none text-ink font-medium transition-all duration-300`}
                style={{ fontFamily: 'Nunito, sans-serif' }}
              >
                Connect your agent →
              </a>
              <Link
                href="/demo/insurance"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-none border border-white/30 dark:border-white/10 text-white font-medium hover:bg-card/10 transition-all duration-300"
                style={{ fontFamily: 'Nunito, sans-serif' }}
              >
                Explore an example
              </Link>
            </div>
          </motion.div>

          {/* Bottom footer */}
          <div className="border-t border-white/10 dark:border-white/10 pt-10 pb-4 w-full">
            <div className="flex flex-col items-center gap-6">
              <div className="flex items-center gap-6">
                <Link
                  href="/privacy"
                  className="text-white/50 text-body-sm font-medium hover:text-white transition-colors duration-200"
                >
                  Privacy
                </Link>
                <span className="text-white/20">·</span>
                <Link
                  href="/terms"
                  className="text-white/50 text-body-sm font-medium hover:text-white transition-colors duration-200"
                >
                  Terms
                </Link>
                <span className="text-white/20">·</span>
                <a
                  href="mailto:founders@sentrial.com"
                  className="text-white/50 text-body-sm font-medium hover:text-white transition-colors duration-200"
                >
                  Contact
                </a>
              </div>
              <span className="text-white/25 text-label">© 2026 Sentrial Inc.</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
